import PropTypes from 'prop-types';
import React from 'react';

import Attribute from '../Attribute';
import { CHARGE_ATTRS } from '../../../../constants';

const getAssessment = (charge, assessmentEnabled) => {
  return assessmentEnabled ? charge?.assessment : null;
};

const CriminalCharge = ({ charge, assessmentEnabled }) => (
  <div className='criminal-charge'>
    {Object.keys(CHARGE_ATTRS).map((key, i) => (
      <Attribute
        key={`attribute-${i + 1}`}
        attr={CHARGE_ATTRS[key]}
        value={charge[key]}
        assessment={getAssessment(
          charge,
          assessmentEnabled && CHARGE_ATTRS[key] === 'Charge',
        )}
      />
    ))}
  </div>
);

CriminalCharge.propTypes = {
  charge: PropTypes.object.isRequired,
  assessmentEnabled: PropTypes.string,
};

CriminalCharge.defaultProps = {
  assessmentEnabled: false,
};

export default CriminalCharge;
